export default {
  name: 'qrcodeSize',
  type: 'layout',
  active: false,
  data: {
    size: '256'
  }
}
